import React from 'react'

import { Text } from './Text'
import { Tooltip } from 'antd'

import Info from '../../Images/info.png'
import { Image } from './Image'
import LucideIcon from './Button'
import { LucideInfo } from 'lucide-react'

const ToolTip = ({ desc, size }) => {
    return (
        <Tooltip
            overlayClassName='roles-tooltip' 
            placement="right"
            arrowPointAtCenter={false} 
            title={
                desc
            }
        >
            <LucideInfo
                icon={LucideInfo}
                size={size || 16} 
                strokeWidth='1.8px'
            />
        </Tooltip>
    )
}

export default ToolTip